<template>
  <!-- 表格查询条件 -->
  <div class="ces-search">
    <el-form class="form" ref="refForm" :size="size" inline :label-width="labelWidth" @submit.native.prevent>
      <el-form-item
        v-for="item in searchForm"
        :label="item.label"
        :key="item.prop"
        class="formItem"
      >
        <!-- 输入框 -->
        <el-input
          id="searchInput"
          clearable
          v-if="item.type==='Input'"
          v-model="searchData[item.prop]"
          size="small"
          :style="{width:item.width}"
          :placeholder="item.placeholder"
        ></el-input>
        <slot name="autosearch"></slot>
        <!-- 下拉框 -->
        <el-select
          id="searchSelect"
          clearable
          v-if="item.type==='Select'"
          v-model="searchData[item.prop]"
          size="small"
          :multiple="item.multiple"
          :collapse-tags="item.collapseTag"
          :filterable="item.filterable"
          @change="item.change(searchData[item.prop])"
          :style="{width:item.width}"
          :placeholder="item.placeholder"
        >
          <el-option
            v-for="(op,index) in item.options"
            :label="op.label"
            :value="op.value"
            :key="op + index"
          ></el-option>
        </el-select>
        <!-- 单选 -->
        <el-radio-group id="searchRadio" v-if="item.type==='Radio'" v-model="searchData[item.prop]">
          <el-radio v-for="ra in item.radios" :label="ra.value" :key="ra.value">{{ra.label}}</el-radio>
        </el-radio-group>
        <!-- 单选按钮 -->
        <el-radio-group
          id="searchRadioButton"
          v-if="item.type==='RadioButton'"
          v-model="searchData[item.prop]"
          @change="item.change && item.change(searchData[item.prop])"
        >
          <el-radio-button v-for="ra in item.radios" :label="ra.value" :key="ra.value">{{ra.label}}</el-radio-button>
        </el-radio-group>
        <!-- 复选框 -->
        <el-checkbox-group
          id="searchCheckbox"
          v-if="item.type==='Checkbox'"
          v-model="searchData[item.prop]"
        >
          <el-checkbox v-for="ch in item.checkboxs" :label="ch.value" :key="ch.value">{{ch.label}}</el-checkbox>
        </el-checkbox-group>
        <!-- 日期 -->
        <el-date-picker
          id="searchDate"
          v-if="item.type==='Date'"
          :value-format="item.format"
          :format="item.format"
          v-model="searchData[item.prop]"
          :placeholder="item.placeholder"
          :style="{width:item.width}"
        ></el-date-picker>
        <!-- 日期时间 -->
        <el-date-picker
          id="searchDateTime"
          v-if="item.type==='DateTime'"
          :value-format="item.format"
          :format="item.format"
          type="datetime"
          v-model="searchData[item.prop]"
          :disabled="item.disable && item.disable(searchData[item.prop])"
          :placeholder="item.placeholder"
        ></el-date-picker>
        <!-- 日期时间范围 -->
        <el-date-picker
          id="searchDateTimeRange"
          v-if="item.type==='datetimerange'"
          :value-format="item.format"
          :format="item.format"
          type="datetimerange"
          size="small"
          v-model="searchData[item.prop]"
          range-separator="至"
          :start-placeholder="item.startPlaceholder"
          :end-placeholder="item.endPlaceholder"
        ></el-date-picker>
        <!-- 日期范围 -->
        <el-date-picker
          v-if="item.type==='daterange'"
          type="daterange"
          value-format="yyyy-MM-dd"
          size="small"
          v-model="searchData[item.prop]"
          range-separator="至"
          :start-placeholder="item.startPlaceholder"
          :end-placeholder="item.endPlaceholder"
        ></el-date-picker>
        <!-- 滑块 -->
        <!-- <el-slider v-if="item.type==='Slider'" v-model="searchData[item.prop]"></el-slider> -->
        <!-- 开关 -->
        <el-switch id="searchSwitch" v-if="item.type==='Switch'" v-model="searchData[item.prop]"></el-switch>
      </el-form-item>
      <el-form-item v-for="(item , index) in searchHandle" :key="index">
        <el-button
          id="serachButton"
          icon="el-icon-search"
          :type="item.type"
          :size="item.size || size"
          @click="item.handle()"
        >{{item.label}}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    isHandle: {
      type: Boolean,
      default: true
    },
    labelWidth: {
      type: String,
      default: "50px"
    },
    size: {
      type: String,
      default: "small"
    },
    searchForm: {
      type: Array,
      default: []
    },
    searchHandle: {
      type: Array,
      default: () => []
    },
    searchData: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>
